import { render, staticRenderFns } from "./ExtraProductCategories.vue?vue&type=template&id=800069a4&scoped=true&"
import script from "./ExtraProductCategories.vue?vue&type=script&lang=js&"
export * from "./ExtraProductCategories.vue?vue&type=script&lang=js&"
import style0 from "./ExtraProductCategories.vue?vue&type=style&index=0&id=800069a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800069a4",
  null
  
)

export default component.exports